import React, {cloneElement, ReactNode, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router";
import {Search} from "../../../filtering";
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import Select from '../../../ui/Select';
import PrimaryButton from '../../../ui/PrimaryButton';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import MoveTypeDropDown from '../../../uiControls/MoveTypeDropDown';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {OceanExportHblPreview, SuntekSettings, SystemSettings} from "../../../ifmsTypes";
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import * as XCol from "../../../framework.core/XExportColumn";
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import ApplicationContext from "../../../ApplicationContext";
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import {JobNames} from "../../../framework.core/JobNames";
import {oceanExportHblList} from "../tableSettings";
import BlackInverseButton from "../../../ui/BlackInverseButton";
import IfmsModal from "../../../ui/IfmsModal";
import fastStorage from "../../../fastStorage";
import HblMilestonePopup from "./HblMilestonePopup";
import ListViewShortcutMenu from "../../common/ListViewShortcutMenu";
import {OeHblListItem, OehListType} from "../../../fms.data/models/OeHblListItem";
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import ToolboxMenuItem from "../../../uiControls/ToolboxMenuItem";
import Menu, { IfmsMenuItem } from "../../../ui/menu/Menu";
import { FmsSubMenu } from "../../../constants/fmsSubMenu";
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from "../../../hooks/useReportViewer";
import loadInfoAreaInvoiceBillCrDb from "../../common/InfoAreaInvoiceBillCrDb";
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, changeRQEvent, LastEventRenderer, LclFclFilterRenderer, LclFclRenderer, RecognizedFilterRenderer, RecognizedRenderer, RQFilterEventRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer, TrackEventNameRenderer } from "../../common/commonListRenderers";
import postal from 'postal';
import { getFmsGlobal } from "../../../globals";
import useSetEditedId from "../../../hooks/useSetEditedId";
import { FmsSecTask } from "../../../fms.core/constants";
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from "../../../util";
import { useJournal } from "../../accounting/general/journal/JournalListView";
import PrimaryInverseButton from "../../../ui/PrimaryInverseButton";
import _ from "lodash";
import RecogModal from "../../../ui/RecogModal";
import constants from "../../../constants";
import { formatLclFcl, formatShipmentType } from "../../common/utils/formatUtils";
import { formatDateTime } from "../../../dateUtils";
import { Decimalformat, displayLastTrackingEvent } from "../../common/commonExportFormat";
import { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { SecType } from "../../../fms.enum";
import JobSwitchingMenuContext from "../../jobSwitchingMenuContext";
import useJobMenus from "../../../hooks/useJobMenus";
import taskReminderIconRed from '../../../img/pin_red.svg';
import cntrGreen from '../../../img/cntr-tracking-rq-12-green.svg';
import cntrBlue from '../../../img/cntr-tracking-rq-12-blue.svg';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}


function HblTypeFilterRenderer({value, onChange}: any) {
  return (
    <Select
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        {value: 'None', label: 'None'},
        {value: 'S', label: 'Standard'},
        {value: 'C', label: 'Co-Load'},
      ]}      
    />
  );
}

function MoveTypeFilterRenderer({value, onChange}: any) {
  return (
    <MoveTypeDropDown
    name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}
    />
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function ContainerRenderer({ cell, value, data, row }: any) {
  const l = data[row.index];
  return (
    <div className="ifms-table-default" id={`oeh-container-${cell.column.id}`} data-tooltip={l.fullContainerNo}>{value}</div>
  );
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedHblOperations();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}{isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function HblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  const { deleteHbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, setSavedEntityOem } =
    useSelectedHblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const {switchJournal} = useJournal();

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityOem(selectedElement.oeMblId?.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);
    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OEHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false); 

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/oeMbl/oceanExport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/oceanExport/mbl/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
    ? `/oceanExport/hbl/add?mblRefId=${jobListContext.f6Query}`
    : '/oceanExport/hbl/add';

  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='oeh-list-add-button' display="primary" link={newUrl} disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='oeh-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='oeh-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='oeh-list-delete-button' disabled={!canBeDeleted} onClick={deleteHbl} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
     <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='oeh-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        {!noBillingsShow && <BillingsIconButton name='oeh-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
        {!noProfitShow && <PrimaryButton name='oeh-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
        <DeleteHistoryIconButton onClick={moveToDeleteHistoryReport} useText />
        <RecogHistoryIconButton onClick={moveToRecogHistoryReport} useText />
        {!checkSecJournal && <JournalIconButton onClick={() =>   switchJournal(JobNames.OEHbl, selectedElement.id, "", null, selectedElement.hblNo)} useText/>}
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.oeMblId} mTbName={"T_OOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function HblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}
function useHblOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToMblFor(hbl: OceanExportHblPreview | null) {
    if (!hbl) {
      return;
    }

    if (hbl.oeMblId) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeMbl/oceanExport', 
      'id', 'Ref. #', hbl.oeMblId ?? 0, 'u2Date', false, true, null, 'refNo', hbl.refNo, false,true);
    }

    openNewPage(history, `/common/joblistview/oeMbl/oceanExport`, NavigationType.newPage);
  }

  function switchToBookingFor(hbl: OceanExportHblPreview | null) {
    if (!hbl) {
      return;
    }

    if (hbl.hblNo) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeBooking/oceanExport', 
      'hblNo', 'HBL #', hbl.hblNo, 'u2Date', false, true);
    }
    else if (hbl.hBookingNo) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeBooking/oceanExport', 
      'hBookingNo', 'Booking #', hbl.hBookingNo, 'u2Date', false, true);
    }
    
    openNewPage(history, `/common/joblistview/oeBooking/oceanExport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(hbl:OeHblListItem|null) {
    if (!hbl) {
      return;
    }

    openNewPage(history, `/accounting/Acct/${JobNames.OEHbl}/${hbl.id}`, NavigationType.newPage);
  }
  return {switchToMblFor, switchToBookingFor, switchToAcctInfo};
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const {switchToMblFor, switchToBookingFor} = useHblOperations();

  const selectedElement = jobListContext.selectedElement as OeHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  
  const setSavedEntityOem = useSetEditedId([JobNames.OEMbl]);
  const setSavedEntityOeBook = useSetEditedId([JobNames.OEBook]);

  function openDocServer(hbl:OeHblListItem|null){
    if (!hbl) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/hbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }
    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/oeMbl/oceanExport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/oceanExport/mbl/edit/' + jobListContext.f6Query;

    const newUrl = openedByF6 || openedByMaster
      ? `/oceanExport/hbl/add?mblRefId=${jobListContext.f6Query}`
      : '/oceanExport/hbl/add';

    openNewPage(history, newUrl, NavigationType.newPage);

  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }
    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OEHB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OEHbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        const editUrl = `/oceanExport/hbl/edit/${selectedElement.id}`;
        const viewUrl = `/oceanExport/hbl/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }
        jobListContext.reloadData();
        setSavedEntityOem(selectedElement.oeMblId?.toString(), false, selectedElement.isSbl);
        setSavedEntityOeBook(selectedElement.id.toString(), false, true);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }
    
    const id = selectedElement.id;
    const editUrl = `/oceanExport/hbl/edit/${id}`;
    const viewUrl = `/oceanExport/hbl/view/${id}`;

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  // �⺻������ View Mode�� �����ϰ� Edit ȭ���� �����ִ� ��� Edit ȭ������ �̵�.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 3;
    const baseUrl = '/oceanExport/hbl';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View�� TabIndex ����
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.OEHbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // �⺻������ View Mode�� �����ϰ� Edit ȭ���� �����ִ� ��� Edit ȭ������ �̵�.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 5;
    const baseUrl = '/oceanExport/hbl';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View�� TabIndex ����
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.OEHbl}TabIndexRequest${id}`] = tabIndex;
    }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }
  
  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OEDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OEHbl}&id=${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OERecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.OEHbl}&id=${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanExport/hbl/edit/${id}`;
    const viewUrl = `/oceanExport/hbl/view/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/hbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanExport/hbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OceanExportHblPreview;
    switchToMblFor(selectedElement);
  }

  function switchToBooking() {
    const selectedElement = jobListContext.selectedElement as OceanExportHblPreview;
    switchToBookingFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return {
    create,
    deleteHbl,
    edit,
    view,
    copy,
    switchToMbl,
    switchToBooking,
    recognize,
    viewBillings,
    moveToDeleteHistoryReport,
    moveToRecogHistoryReport,
    viewProfit,
    setSavedEntityOem,
    openDocServer
  };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMbl, switchToBooking, recognize, viewBillings, viewProfit } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as any;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch);
  const bookingSec = findSecurityTask(appContext, FmsSecTask.OEBook);
  const mblSec = findSecurityTask(appContext, FmsSecTask.OEMbl);
  const fmsGlobal = getFmsGlobal();
  const setSavedEntityOem = useSetEditedId([JobNames.OEMbl]);
  const setSavedEntityAfterClose = useSetEditedId([JobNames.OEBook]);
  const userID = appContext.user ? appContext.user.id ?? '' : '';

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OEHbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

     const hasOpened =
    jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/view/${selectedElement.id}`)

    if (selectedElement.isClosed && hasOpened) {
      const editModelKey = `editOeHbl${selectedElement.id}-/oceanExport/hbl/edit`;
      const viewModelKey = `viewOeHbl${selectedElement.id}-/oceanExport/hbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isFileClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;
      }
    }else if (!selectedElement.isClosed && hasOpened) {
      const editModelKey = `editOeHbl${selectedElement.id}-/oceanExport/hbl/edit`;
      const viewModelKey = `viewOeHbl${selectedElement.id}-/oceanExport/hbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_OOHMAIN',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    if (selectedElement.isSbl)
      setSavedEntityOem(selectedElement.oeMblId?.toString(), false);
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    const accountLockResult = await appContext.api.accountClose(JobNames.OEHbl, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult,false,null,'warning');
      return;
    }

      const hasOpened =
    jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/view/${selectedElement.id}`)

    if (selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editOeHbl${selectedElement.id}-/oceanExport/hbl/edit`;
      const viewModelKey = `viewOeHbl${selectedElement.id}-/oceanExport/hbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));


      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
      }if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
      }
    }else if (!selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editOeHbl${selectedElement.id}-/oceanExport/hbl/edit`;
      const viewModelKey = `viewOeHbl${selectedElement.id}-/oceanExport/hbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_OOHMAIN',
        fieldName: 'F_AcctCloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
      }if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    if (selectedElement.isSbl)
      setSavedEntityOem(selectedElement.oeMblId?.toString(), false);
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Booking List', shortcut: 'F4', separator: false , hidden : !bookingSec?.grantRead },
    { label: 'Search', shortcut: 'F5', separator: false },


    { label: 'Go to MBL List', shortcut: 'F6', separator: false, hidden: !mblSec?.grantRead },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: listSec?.grantEdit ?? false, hidden: noProfitShow},
    // { label: 'View B/L Activity Status', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];
  
  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="oeh-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        switchToBooking();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToMbl();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        copy();
        break;
      case 9:
        viewBillings();
        break;
      case 10:
        viewProfit();
        break;
      case 11:
        processFileLock();
        break;
      case 12:
        processAccountLock();
        break;
      case 13:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function HblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as any;
  const history = useHistory();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch);

  const {copy, create, edit, view, switchToMbl, switchToBooking, viewBillings, viewProfit} = useSelectedHblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);
    const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  
  const mblSec = findSecurityTask(appContext, FmsSecTask.OEMbl);
  const bookSec = findSecurityTask(appContext, FmsSecTask.OEBook);


  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
     if (mblSec.grantRead)
        switchToMbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F4" && bookSec.grantRead) {
      switchToBooking();
    } else if (unprocessedFkey === "CTRL+F2") {
      copy();
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `HBL #: ${(jobListContext.selectedElement as OeHblListItem|null)?.hblNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportHbl}
      jobName={JobNames.OEHbl}
      //entityId={(jobListContext.selectedElement as oceanExportHblPreview|null)?.id}
      jobId={(jobListContext.selectedElement as OceanExportHblPreview | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      isSingleBl={(jobListContext.selectedElement as OeHblListItem|null)?.isSbl}
    />
  );
}

function formatData(data:Array<OeHblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for HBL List screen
 *
 * @class HblListView
 * @extends {AbstractListView}
 */
class HblListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  oceanExportHblList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = OeHblListItem.getExportCollection(OehListType.Normal, useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'lclFcl',   //'containerMode',
        renderer: LclFclFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'hblType',
        renderer: HblTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== null ? changeRQEvent(v): "",
      },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;

    return OeHblListItem.getExportCollection(OehListType.Normal, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === 'memoCnt') colRenderer.Cell = MemoDetailRenderer;
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if(x.dataIndex === "refNo") colRenderer.Cell = RefNoRenderer;
      else if(x.dataIndex === "amsBlNo") colRenderer.Cell = TextAlignLeftRenderer;
      // else if (x.dataIndex === 'recognized') {
      //   colRenderer.Cell = RecognizedRenderer;
      // }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'sName' || x.dataIndex === 'cName' || x.dataIndex === 'nName') colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if (x.dataIndex === 'aName') colRenderer.Cell = AgentRenderer;
      else if (x.dataIndex === 'payStat') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'containerNo') colRenderer.Cell = ContainerRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if(x.dataIndex === 'kgs' )
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={systemSettings?.bl?.kgslbsDecimal ?? 0} />;
        else if(x.dataIndex === 'cbm' )
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={3} />;
          else
          colRenderer.Cell = FloatRenderer;
      }
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OEHbl} />;
        colRenderer.Header =  () => <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>;
      } if (x.dataIndex === 'lclFcl') {
        colRenderer.Cell = LclFclRenderer;
      }
      
      // debugger
      return colRenderer;
    });

  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'cbm', changedValue: (value: any) => { return Decimalformat(value['cbm'],3) } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],2) } });
    colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],2) } });
    colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
    colRenderer.push({ accessor: 'lastEvent', changedValue: (value: any) => { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '') } });
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { return displayLastTrackingEvent(value)}});
    colRenderer.push({accessor: 'lclFcl', changedValue: (value: any)=> { return formatLclFcl(value['lclFcl'])}});
    
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OEHbl,
      'OeHblListItem',
      OeHblListItem.calculateSearchParameters(search, OeHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }
    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OEHbl, 'OeHblListItem',
      OeHblListItem.calculateSearchParameters(search, OeHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }


  renderCommands(): ReactNode {
    return (
      <HblListCommands/>
    );
  }

  renderBeforeConfigureButton(): ReactNode {
    return (
      <HblListToolbar/>
    );
  }

  renderAfterConfigureButton(): ReactNode {
    return <></>
  }

  renderExtras(hideLogHistory: boolean): ReactNode {
    return <HblListViewExtras hideLogHistory={hideLogHistory} />
  }

  public renderInsideTopRightOpMenu(): React.ReactNode {
    return (
      <BlackInverseButton size="large" data-tooltip="Container Tracking" >
        <ContainerTrackingIcon width={20} height={20} />
      </BlackInverseButton>
    );
  }

  getViewUrlFor(row: OceanExportHblPreview) {
    return row && row.id ? `/oceanExport/hbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'HBL List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    const storageKey = `oe-hbl-milestone-${rowId}`;
    const selectedElement = context.selectedElement as OeHblListItem;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement.branch);

    function onClose() {
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="B/L Status" width="760px">
        <HblMilestonePopup hblId={rowId} storageKey={storageKey} onClose={onClose} isView={!listSec?.grantEdit} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OEHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }
};

export default HblListView;
